var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Download",
    "data-name": "Icon - Download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff;opacity:0}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px;stroke-miterlimit:10}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Download-2",
    "data-name": "Icon - Download",
    transform: "translate(1.339 4.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(2.009 1.339)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5690",
    "data-name": "Group 5690",
    transform: "translate(4.937 -1.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5692",
    "data-name": "Group 5692",
    transform: "translate(-.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_376",
    "data-name": "Line 376",
    className: "cls-2",
    transform: "translate(3.999 -.5)",
    d: "M0 0v8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_377",
    "data-name": "Line 377",
    className: "cls-2",
    transform: "translate(0 4.999)",
    d: "M4 4 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_378",
    "data-name": "Line 378",
    className: "cls-2",
    transform: "translate(4 4.999)",
    d: "m0 4 4-4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7926",
    "data-name": "Path 7926",
    d: "M-3262.583-23223v3.254h17v-3.254",
    transform: "translate(3262.735 23233.225)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/IconDownloadWhite.00428e1c3a0d26a171ff9da9a669e0da.svg";
export { ForwardRef as ReactComponent };